<template>
  <div class="accountDetail">
    <common-title bcColor="" titleName="账户明细" :isAPPShow="true"></common-title>
    <div class="accountDetail__scroll_box">
      <div class="account">
        <div class="account_bg"></div>
        <div class="account_main">
          <div class="account__cash">
            <div class="account__cash-mine">
              <div @click="onViewTip">现金账户 <img
                  src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/invitationCommission/invite_tip.png"
                  alt=""></div>
              <div>{{ formatMoney(accountInfo.accountAmount) }}</div>
            </div>
          </div>
          <div class="account__info">
            <div class="account__info-item" @click="onViewWithdrawDetail">
              <div class="desc">
                可提现(元)<img
                  src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/invitationCommission/invite_right.png"
                  alt="">
              </div>
              <div class="num">
                {{ formatMoney(accountInfo.withdrawAmount) }}
              </div>
            </div>
            <div class="account__info-item">
              <div class="desc" @click="onViewTip">
                冻结中(元)<img
                  src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/invitationCommission/invite_tip.png"
                  alt="">
              </div>
              <div class="num">
                {{ formatMoney(accountInfo.freezeAmount) }}
              </div>
            </div>
          </div>
        </div>
        <div class="account_extra">
          <div class="account_extra-item">
            <div class="desc">
              <span>累计奖金（元）</span>
              <img
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/invitationCommission/invite_money.png"
                alt="">
            </div>
            <div class="num">
              {{ formatMoney(accountInfo.totalCommission) }}
            </div>
          </div>
          <div class="account_extra-item">
            <div class="desc">
              <span>累计提现（元）</span>
              <img
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/invitationCommission/invite_withdraw.png"
                alt="">
            </div>
            <div class="num">
              {{ formatMoney(accountInfo.totalWithdraw) }}
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="content_title">奖金明细</div>
        <div class="content_list">
          <div :class="`list_header list-item ${this.$root.miniprogram ? 'mini' : ''}`">
            <span>好友</span>
            <span>奖金(元)</span>
            <span>状态</span>
            <span>入账时间</span>
          </div>
          <van-list v-model="loading" :finished="finished" :immediate-check="false" :offset="20" v-if="list.length"
            @load="getList">
            <ul class="list_body">
              <li class="list_body-item list-item" v-for="(item, keys) in list" :key="keys">
                <span>{{ phoneNuberConvert(item.phone) }}</span>
                <span>{{ formatMoney(item.commission) }}</span>
                <span>
                  <img
                    :src="`https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/invitationCommission/account_status${item.status}.png`" />
                </span>
                <span>{{ formatTime(item.commissionStartTime) }}</span>
              </li>
            </ul>
          </van-list>
          <div class="empty" v-if="!list.length">
            <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/invitationCommission/empty.png" alt="">
            <span>暂无数据～</span>
          </div>
        </div>
      </div>
    </div>
    <van-overlay :show="showTip" @click="showTip = false">
      <div class="wrapper" @click.stop>
        <div class="wrapper__title">
          <span></span>
          <span>说明</span>
          <img @click="showTip = false"
            src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/invitationCommission/invite_close.png"
            alt="">
        </div>
        <div class="wrapper__content">您与好友购课30天后即可提现哦</div>
      </div>
    </van-overlay>
    <Share :basicInfo="basicInfo" :accountInfo="accountInfo"></Share>
  </div>
</template>
<script>
import { mapState } from 'vuex';
// eslint-disable-next-line import/no-cycle
import {
  reqUserAccount,
  reqAccountDetailList,
  reqInvitationInfo,
} from '@/api/invitationCommission';

import CommonTitle from '@/components/header/CommonTitle.vue';
import { phoneNuberConvert, formatMoney } from '@/utils/tools';
import Share from '../components/ShareInvitation/index.vue';

export default {
  components: {
    CommonTitle,
    Share,
  },
  data() {
    return {
      showTip: false,
      basicInfo: {},
      accountInfo: {},
      pageSize: 10,
      pageNum: 1,
      list: [],
      loading: false,
      finished: false, // 是否加载到最后
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  beforeRouteEnter(to, from, next) {
    const token = window.localStorage.getItem('accessToken');
    if (token) {
      next();
    } else {
      next((vm) => {
        vm.$root.openLogin('/invitation/accountDetail');
      });
    }
  },
  mounted() {
    document.title = '账户明细';
    this.$toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: 0,
    });
    this.initData();
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) {
        document.title = '账户明细';
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration: 0,
        });
        this.initData();
      }
    });
  },
  methods: {
    initData() {
      this.getInvitationInfo();
      this.pageNum = 1;
      this.list = [];
      this.finished = false;
      this.$nextTick(() => {
        this.initPage();
      });
    },
    phoneNuberConvert,
    formatMoney,
    formatTime(timeStr) {
      return timeStr?.split(' ')[0]?.replaceAll('-', '/') || '--';
    },
    initPage() {
      console.log(1111);
      if (!this.userInfo?.id) return;
      this.getUserAccount();
      this.getList();
    },
    getList() {
      this.loading = true;
      const params = { pageSize: this.pageSize, pageNum: this.pageNum };
      reqAccountDetailList(params).then((res) => {
        const { data, pages, pageNum } = res;
        if (pageNum >= pages) {
          this.finished = true;
          this.list = [...this.list, ...data];
        } else {
          this.list = [...this.list, ...data];
          this.pageNum += 1;
        }
        console.log('[...this.list, ...data]', [...this.list, ...data])
      }).finally(() => {
        this.loading = false;
      });
    },
    // 查看活动基本信息
    getInvitationInfo() {
      reqInvitationInfo().then((res) => {
        this.basicInfo = res;
      });
    },
    // 查看我的账户信息
    getUserAccount() {
      reqUserAccount().then((res) => {
        this.accountInfo = res;
      }).finally(() => {
        this.$toast.clear();
      });
    },
    onViewTip() {
      this.showTip = true;
    },
    onViewWithdrawDetail() {
      this.$router.push({
        path: '/invitation/withdrawDetail?back=back',
      });
    },
    onSubscribe() {
      if (this.accountInfo) {
        console.log(11111);
      } else {
        this.$router.push({
          path: '/invitation/subscribe?back=back',
        });
      }
    },

  },

  watch: {
    userInfo: {
      deep: true,
      handler(val) {
        if (!val?.id) {
          // 区分App和h5
          if (!(this.$root.$data.isApp || this.$root.$data.miniprogram)) {
            const { path } = this.$route;
            this.$router.push({
              path: '/registrationLogin',
              query: { redirect: path },
            });
          }
        } else {
          this.initData();
        }
      },
    },
  },
};
</script>

<style scoped lang="scss">
.accountDetail {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #F7F8FC;

  &__scroll_box {
    width: 100%;
    height: calc(100% - 196px);
    padding-top: 116px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .account {
    position: relative;
    // z-index: 10;
    width: 750px;
    // height: 638px;

    &_bg {
      position: absolute;
      top: -116px;
      left: 0;
      width: 100%;
      height: 373px;
      background-image: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/invitationCommission/invite_bg.png');
      background-repeat: no-repeat;
      background-position: 0 -80px;
      background-size: 750px 453px;
    }

    &_main {
      // position: absolute;
      // bottom: 0;
      // left: 50%;
      position: relative;
      left: 50%;
      z-index: 11;
      width: 678px;
      // height: 301px;
      padding: 33px 36px 36px;
      background: #FFF;
      background-image: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/invitationCommission/invite_main_top.png');
      background-repeat: no-repeat;
      background-size: 678px 89px;
      border-radius: 25px;
      transform: translateX(-50%);

      .account__cash {
        display: flex;
        justify-content: space-between;
        height: 153px;

        &-mine {
          & div:first-child {
            width: 145px;
            height: 36px;
            color: #333;
            font-weight: 500;
            font-size: 25px;
            font-style: normal;
            line-height: 36px;
            text-align: left;

            img {
              display: inline-block;
              width: 22px;
              height: 22px;
            }
          }

          & div:last-child {
            width: 246px;
            height: 112px;
            margin-top: 5px;
            color: #FF7F41;
            font-weight: 600;
            font-size: 80px;
            font-style: normal;
            line-height: 112px;
            text-align: left;
          }
        }

        .rule {
          width: fit-content;
          height: 31px;
          color: #FF7F41;
          font-weight: 500;
          font-size: 22px;
          font-style: normal;
          line-height: 31px;
          text-align: left;
        }
      }
    }

    &_extra {
      position: relative;
      left: 50%;
      display: flex;
      justify-content: space-between;
      width: 678px;
      height: 192px;
      margin-top: 29px;
      transform: translateX(-50%);

      &-item {
        width: 330px;
        height: 192px;
        padding: 36px 36px 0;
        background: #FFF;
        border-radius: 14px;

        .desc {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 36px;
          color: #999;
          font-weight: 400;
          font-size: 25px;
          font-style: normal;
          line-height: 36px;

          img {
            display: inline-block;
            width: 36px;
            height: 36px;
          }
        }

        .num {
          height: 76px;
          margin-top: 7px;
          color: #333;
          font-weight: 600;
          font-size: 54px;
          font-style: normal;
          line-height: 76px;
          text-align: left;
        }
      }
    }

    &__info {
      display: flex;

      &-item {
        flex: 1;

        .desc {
          height: 31px;
          color: #999;
          font-weight: 400;
          font-size: 22px;
          font-style: normal;
          line-height: 31px;
          text-align: left;

          img {
            display: inline-block;
            width: 5px;
            height: 11px;
            margin-left: 7px;
          }
        }

        &:nth-child(2) {
          img {
            position: relative;
            top:4px;
            display: inline-block;
            width: 22px;
            height: 22px;
          }
        }

        .num {
          height: 40px;
          margin-top: 4px;
          color: #333;
          font-weight: 600;
          font-size: 29px;
          font-style: normal;
          line-height: 40px;
          text-align: left;
        }
      }
    }

    &_ad {
      padding: 446px 36px 196px;

      img {
        display: block;
        width: 100%;
      }
    }
  }

  .content {
    padding-top: 43px;

    .content_list {
      width: 678px;
      margin: 0 auto;
      background: #FFF;
      border-radius: 14px;
    }

    .content_title {
      padding: 0 36px 22px;
      color: #111;
      font-weight: 500;
      font-size: 29px;
      font-style: normal;
      line-height: 40px;
      text-align: left;
    }

    .list_header {
      position: sticky;
      top: 116px;
      width: 678px;
      height: 91px;
      padding: 27px 29px 0;
      background-image: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/invitationCommission/detail_list.png');
      background-repeat: no-repeat;
      background-size: 678px 91px;

      &.mini {
        top: 0;
      }

      span {
        height: 36px;
        color: #999;
        font-weight: 400;
        font-size: 25px;
        font-style: normal;
        line-height: 36px;
        text-align: left;
      }
    }

    .list-item {
      display: flex;
      width: 678px;
      margin: 0 auto;

      span {
        &:nth-child(1) {
          width: 190px;
        }

        &:nth-child(2) {
          width: 154px;
        }

        &:nth-child(3) {
          width: 131px;
        }

        &:nth-child(4) {
          flex: 1;
        }
      }
    }

    // .list_main {
    //   max-height: calc(100vh - 1030px);
    //   overflow-x: hidden;
    //   overflow-y: scroll;
    // }

    .list_body {
      padding-bottom: 49px;

      .list_body-item {
        align-items: center;
        margin-top: 43px;
        padding: 0 29px;

        span {
          &:nth-child(1) {
            height: 36px;
            color: #333;
            font-weight: 500;
            font-size: 25px;
            font-style: normal;
            line-height: 36px;
            text-align: left;
          }

          &:nth-child(2) {
            height: 36px;
            color: #FF7F41;
            font-weight: 500;
            font-size: 25px;
            font-style: normal;
            line-height: 36px;
            text-align: left;
          }

          &:nth-child(3) {
            display: flex;

            img {
              width: 94px;
              height: 36px;
            }
          }

          &:nth-child(4) {
            height: 36px;
            color: #333;
            font-weight: 500;
            font-size: 25px;
            font-style: normal;
            line-height: 36px;
            text-align: left;
          }
        }
      }
    }
  }

  ::v-deep .commonTitle {
    background-image: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/invitationCommission/invite_bg.png');
    background-repeat: no-repeat;
    background-size: 750px 453px;
  }

  ::v-deep .commonTitle .backButton {
    background-image: url('https://iqh-zt-pord-cdn.iqihang.com/ark-question-bank/white-back.png');
    background-repeat: no-repeat;
    background-size: 100%;
  }

  ::v-deep .commonTitle .titleName {
    color: #fff;
  }

  ::v-deep .van-overlay {
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .wrapper {
    width: 634px;
    height: 259px;
    padding: 31px 33px 0;
    background: #FFF;
    border-radius: 36px;

    &__title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
      color: #333;
      font-weight: 500;
      font-size: 29px;
      font-style: normal;
      line-height: 40px;
      text-align: center;
      span {
        font-weight: 500;
      }

      & img {
        display: inline-block;
        width: 29px;
        height: 29px;
      }
    }

    &__content {
      height: 43px;
      margin-top: 62px;
      color: #333;
      font-weight: 400;
      font-size: 29px;
      font-style: normal;
      line-height: 43px;
      text-align: center;
    }
  }

  .empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 100px;

    img {
      width: 308px;
      height: 219px;
      margin-bottom: 13px;
    }

    span {
      color: #999;
      font-weight: 400;
      font-size: 25px;
      font-style: normal;
      line-height: 36px;
      text-align: right;
    }
  }
}
</style>
